import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import { useState } from "react";
import SearchBar from "../../../components/SearchBar";
import SwitchToggle from "../../../components/SwitchToggle";
import AddBrand from "../../../Modals/addBrand";

const ManageBrands = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const [rows] = useState([
    { id: 1, name: "Audi", createdDate: "01-Sept-2025", status: true },
    { id: 2, name: "BMW", createdDate: "01-Sept-2025", status: true },
    { id: 3, name: "Ford", createdDate: "01-Sept-2025", status: true },
    { id: 4, name: "Mercedes-Benz", createdDate: "01-Sept-2025", status: true },
    { id: 5, name: "Opel", createdDate: "01-Sept-2025", status: true },
    { id: 6, name: "Renault", createdDate: "01-Sept-2025", status: true },
    { id: 7, name: "Skoda", createdDate: "01-Sept-2025", status: true },
    { id: 8, name: "Tesla", createdDate: "01-Sept-2025", status: true },
    { id: 9, name: "Toyota", createdDate: "01-Sept-2025", status: true },
    { id: 10, name: "Volvo", createdDate: "01-Sept-2025", status: true },
    { id: 11, name: "Volkswagen", createdDate: "01-Sept-2025", status: true },
  ]);

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  return (
    <>
      <div className="main_title">
        <h1>Manage Brands
        </h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Brands
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search Sub-Categories..."
            />
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => setOpenModal(true)}
            >
              <AddIcon /> Add Brand
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No.</TableCell>
                <TableCell>Brand Detail</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Enable/Disable</TableCell>
                <TableCell>Popular</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <TableRow hover key={row.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    <div className="user_block">
                      <figure className="no_radius">
                        <img src="/static/images/placeholder.png" alt={row.name} />
                      </figure>
                      <p>
                        <b>{row.name}</b>
                      </p>
                    </div>
                  </TableCell>
                  <TableCell>{row.createdDate}</TableCell>
                  <TableCell>
                    <SwitchToggle defaultChecked={row.status} />
                  </TableCell>
                  <TableCell><SwitchToggle /></TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton
                        onClick={() => navigate('/manage-brands/detail')}
                      >
                        <img src="/static/images/eye_icon.svg" alt="View" />
                      </IconButton>
                      <IconButton
                        onClick={() => setOpenModal(true)}
                      >
                        <img src="/static/images/edit2_icon.svg" alt="Edit" />
                      </IconButton>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <AddBrand
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default ManageBrands;